var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatusLiveUpdates = function SvgStatusLiveUpdates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1875 17.2727V7.72727C15.1875 6.08949 13.7952 4.625 11.9062 4.625C10.0173 4.625 8.625 6.08949 8.625 7.72727V17.2727C8.625 18.9105 10.0173 20.375 11.9062 20.375C13.7952 20.375 15.1875 18.9105 15.1875 17.2727ZM11.9062 2C8.64432 2 6 4.56419 6 7.72727V17.2727C6 20.4358 8.64432 23 11.9062 23C15.1682 23 17.8125 20.4358 17.8125 17.2727V7.72727C17.8125 4.56419 15.1682 2 11.9062 2Z",
    fill: "#B2D145"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 3,
    r: 2.5,
    fill: "#FAFAFA",
    stroke: "#093239"
  })));
};
export default SvgStatusLiveUpdates;